import { AccessChecker } from 'mycorems-app-accounts';
import rules from './rules';

const accessChecker = new AccessChecker(rules, 'content');

export default function (action, ...args) {
  return accessChecker.isGranted(action, args);
}
